import { Component, OnInit } from '@angular/core';
import { BreadCrumbService, BreadCrumbModel, PageLoaderService, StepIndicatorService, StepIndicatorModel, 
  MobilePivotModel} from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService } from './../../../lib/ng2-sapmp/src/providers';
import { STEPINDICATORS } from './../../../config';
import { ENV, MOBILEPIVOTS } from 'config';
import { GroupingDevicesService } from './grouping-devices.service';
declare var ENV_VAR: any;

@Component({
  templateUrl: './grouping-devices.component.html',
  styleUrls: ['./grouping-devices.component.scss'],
  providers: [StepIndicatorService,GroupingDevicesService]
})
export class GroupingDevicesComponent implements OnInit {

  public steps: Array<StepIndicatorModel>;
  public pivots: Array<MobilePivotModel>;
  public errorMessage: any;
  public currentStep: any;

  constructor(private breadCrumbService: BreadCrumbService,
    private spinner: PageLoaderService,
    private stepIndicator: StepIndicatorService,
    private utilities: UtilityService,) {
      this.steps = JSON.parse(JSON.stringify(STEPINDICATORS.groupingDevices));
      this.errorMessage = {
        'heading': 'Something went wrong.',
        'subHeading': 'Please try again',
        'show': false
      };
     }

  ngOnInit(): void {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = 'Group Devices';
    breadcrumb.routerLink = '/groupingDevices';
    const callingPage = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    const pivots = JSON.parse(JSON.stringify(MOBILEPIVOTS.SMSPAGE)); // create new const in mobilepivots
    this.breadCrumbService.setCurrentBreadCrumb(breadcrumb);
    this.stepIndicator.setCurrentStep('selectDevices');
    this.stepIndicator.setVisibility(true);
    pivots.unshift({ label: 'Device Inventory', routerLink: callingPage });
    this.pivots = pivots;
    this.stepIndicator.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path + ' step';
    });

  }

}
